import React from 'react';
import { ArrowRightIcon, CheckIcon, ClockIcon, LockIcon } from 'lucide-react';
import { bundle, checkoutUrl, ebookImage, price } from '../data/content';
import { trackEvent } from '../utils/metaPixel';
export function Offer() {
  return <section id="oferta" className="bg-teal-deep text-white" data-id="element-134" data-mp="1mmzem6sx1956">
      <div className="mx-auto grid max-w-5xl gap-12 px-6 py-16 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:py-24" data-id="element-135" data-mp="1ho5x83aicxzq">
        <img src={ebookImage} alt="Bundle completo del Método Vientre Plano 21D mostrado en una tablet" className="w-full rounded-[2rem] object-cover" loading="lazy" data-id="element-136" data-mp="tzmpbovden86" />

        <div data-id="element-137" data-mp="13ylxl6c84gun">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl" data-id="element-138" data-mp="13uy76g22sak5">
            Obtén el Bundle Completo del Método Vientre Plano 21D hoy mismo
          </h2>
          <p className="mt-5 max-w-prose leading-relaxed text-white/80" data-id="element-139" data-mp="2feao27oory07">
            Todo lo que necesitas para resetear tu cuerpo y volver a sentirte
            cómoda en tu propia piel.
          </p>

          <ul className="mt-8 space-y-2.5" data-id="element-140" data-mp="pmbgbtoa124z">
            {bundle.map(item => <li key={item.name} className="flex gap-3 text-sm leading-relaxed text-white/85" data-id="element-141" data-mp="uhqvqq1xn63i">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-142" data-mp="13jq9n9hnhu28" />
                {item.name}
              </li>)}
          </ul>

          <div id="precio" className="mt-10 scroll-mt-16 rounded-2xl bg-white/10 p-6 ring-1 ring-white/15" data-id="element-143" data-mp="bs12469woqd6">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-teal-soft" data-id="element-144" data-mp="fsb4za2ej0nt">
              {price.label}
            </p>
            <div className="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-145" data-mp="3k8vv8u0wiwe2">
              <p className="font-display text-4xl font-semibold" data-id="element-146" data-mp="3oa7mf3zfbpod">
                {price.amount}{' '}
                <span className="text-lg font-medium text-white/70" data-id="element-147" data-mp="vfqw9zv6z8r5">
                  {price.currency}
                </span>
              </p>
              <p className="text-lg text-white/50 line-through" data-id="element-148" data-mp="qfurvzil1fb2">
                {price.original}
              </p>
              <p className="rounded-full bg-gold px-2.5 py-1 text-xs font-semibold text-ink" data-id="element-149" data-mp="1550m192kcfc3">
                {price.discount} de descuento
              </p>
            </div>
            <a href={checkoutUrl} onClick={() => trackEvent('AddToCart', {
            content_name: 'Método Vientre Plano 21D',
            content_type: 'product',
            value: 6390,
            currency: 'CLP'
          })} className="group mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-4 text-center text-base font-semibold text-ink transition-colors duration-150 ease-smooth hover:bg-[#c69c58] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-teal-deep" data-id="element-150" data-mp="chxrst4x6qrn">
              ¡Sí, quiero mi vientre plano ahora!
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-151" data-mp="25bnmijs36fdc" />
            </a>
            <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-white/70" data-id="element-152" data-mp="1vhdvp6islp4q">
              <li className="inline-flex items-center gap-2" data-id="element-153" data-mp="2j5x0hc2mvjs2">
                <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="2o36ocnadjnds" />
                Acceso instantáneo después del pago
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-155" data-mp="29d97kserxzym">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-156" data-mp="2ed3z8y6ditkq" />
                Oferta por tiempo limitado
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}